import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import features from '~/constants/features';
import { SalesforceSoftDeclineImg } from '~/img';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import { useGetApplication } from '~/controllers/wizard';
import theme from '~/constants/theme';
import colors from '~/constants/colors';
import UpdateApplicationButton from './UpdateApplicationButton';
import DeclineReasonsList from './DeclineReasonsList';
import { getErrorMessages } from './utils';

const SoftRejectionWithoutcardholder: FC = () => {
  const { t } = useTranslation('stageResult');

  const applicationQuery = useGetApplication();
  const softDeclineStagePayload =
    applicationQuery.data?.stage === 'salesforceSoftDecline' ? applicationQuery.data.stagePayload : undefined;

  return (
    <WizardContent
      content={
        <Container className="SalesforceSoftDecline">
          <div className="SalesforceSoftDecline-Content">
            <SalesforceSoftDeclineImg className="SalesforceSoftDecline-Img" />
            <Typography.Title className="SalesforceSoftDecline-Title">{t('We need more information')}</Typography.Title>
            <Typography.Paragraph className="SalesforceSoftDecline-Paragraph">
              <p>
                {t(
                  'Thank you for your application. We have reviewed the information submitted to us and require some clarifications.',
                )}
              </p>
              {softDeclineStagePayload?.allowToResubmit ? (
                <>
                  <p>
                    {t(
                      "We request you to select 'Update Application' below and review the following details which you provided:",
                    )}
                  </p>
                  <p>
                    <DeclineReasonsList errors={softDeclineStagePayload.errors} />
                  </p>
                  <p>
                    <Trans
                      t={t}
                      i18nKey="Please contact us via our <1>Contact us page</1> if you need any support or have any questions."
                    >
                      {'Please contact us via our '}
                      <a href={features.contactUsLinkSoftDecline} target="__blank">
                        Contact us page
                      </a>
                      {' if you need any support or have any questions.'}
                    </Trans>
                  </p>
                </>
              ) : softDeclineStagePayload?.errors.length === undefined ? (
                <p>{t("We'll call you back soon for further information.")}</p>
              ) : softDeclineStagePayload.errors.length === 1 ? (
                getErrorMessages(softDeclineStagePayload.errors).map((message: any) => {
                  return <p key={message.message}>{message}</p>;
                })
              ) : softDeclineStagePayload.errors.length > 1 ? (
                <DeclineReasonsList errors={softDeclineStagePayload.errors} />
              ) : null}
            </Typography.Paragraph>
            {softDeclineStagePayload?.allowToResubmit && (
              <div className="SalesforceSoftDecline-UpdateApplicationBtn">
                <UpdateApplicationButton />
              </div>
            )}
          </div>
          <div className="SalesforceSoftDecline-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLinkSoftDecline} contactUsTextPosition="left" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .SalesforceSoftDecline-Content {
    position: relative;
    .SalesforceSoftDecline-Img {
      width: 100%;
      margin-bottom: 32px;
    }
    .SalesforceSoftDecline-Title {
      position: absolute;
      top: 25%;
      left: 5%;
      width: 35%;
      color: ${colors.layoutBodyBackground} !important;
    }
    .SalesforceSoftDecline-Paragraph {
      margin-left: 5%;
    }
    .SalesforceSoftDecline-UpdateApplicationBtn {
      margin-top: 32px;
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .SalesforceSoftDecline-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
        color: ${colors.primaryTitleColor} !important;
      }
      .SalesforceSoftDecline-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SalesforceSoftDecline-Paragraph {
        margin-left: 0;
      }
      .SalesforceSoftDecline-UpdateApplicationBtn {
        margin-left: 0;
      }
    }
  }
  .SalesforceSoftDecline-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .SalesforceSoftDecline-ContactUs {
      display: none;
    }
  }
`;

export default SoftRejectionWithoutcardholder;
